import React from "react";
import InsightPlacement2022 from "../components/InsightsComponents/InsightsPlacement";
export default function Insight() {
  return (
    <div>
      <InsightPlacement2022 />
    </div>
  );
}
